import { useState, useEffect } from 'react';
import sanitizeInput from '../utils/sanitizeInput';
/**
 * Custom hook to manage chat messages state including cached messages, prompts, and sanitized payloads
 * @returns Object containing chat message states and their setter functions
 * @public
 */
export const useChatMessagesState = props => {
  const {
    submitChatMessagesPayload
  } = props;
  const [chatMessages, setChatMessages] = useState([]);
  const [santizedSubmitChatMessagesPayload, setSanitizedSubmitChatMessagesPayload] = useState(submitChatMessagesPayload);
  // This useEffect only handles pushPrompt sanitization for deeplink functionality
  useEffect(() => {
    if (!submitChatMessagesPayload) return;
    const {
      isPortal = false
    } = submitChatMessagesPayload;
    // Start with a copy of the original payload
    let updatedPayload = Object.assign({}, submitChatMessagesPayload);
    // Handle pushPrompt sanitization for deeplink functionality
    if (updatedPayload.pushPrompt && !isPortal) {
      updatedPayload = Object.assign(Object.assign({}, updatedPayload), {
        pushPrompt: sanitizeInput(updatedPayload.pushPrompt)
      });
    }
    // Update the sanitized payload state
    setSanitizedSubmitChatMessagesPayload(updatedPayload);
  }, [submitChatMessagesPayload]);
  return {
    chatMessages,
    setChatMessages,
    santizedSubmitChatMessagesPayload,
    setSanitizedSubmitChatMessagesPayload
  };
};